<template>
    <div>
        <h5>{{activeSolution.details.title}}</h5>
        <div>
            {{activeSolution.details.description}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "NavSolutionBlock",
        props: ['activeSolution'],
        data() {
            return {}
        }
    }
</script>

<style lang="scss" scoped>

</style>